import { StateValidator } from '../../services/filter-state/filter-state.service';

export interface ActivityStreamFilterState {
  sortKey: string;
  filterKey: string;
}

export const DEFAULT_ACTIVITY_STREAM_FILTER_STATE: ActivityStreamFilterState = {
  sortKey: 'createdDateTimeDesc',
  filterKey: 'allActivities'
};

export const isValidActivityStreamFilterState: StateValidator<ActivityStreamFilterState> = (
  obj: unknown
): obj is ActivityStreamFilterState => {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  const state = obj as Record<string, unknown>;
  if (typeof state.sortKey !== 'string') return false;
  if (typeof state.filterKey !== 'string') return false;
  return true;
};
